// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"472":"settings","597":"projects","809":"users","884":"admin"}[chunkId] + "." + {"472":"f94fa318","597":"553a22a3","809":"ea9da7f8","884":"b7640611"}[chunkId] + ".js";
};